import React, { useState, useEffect } from 'react';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import StorageManager from '../context/StorageManager';
import Swal from 'sweetalert2';
import { Card, Spinner, Button, Tab, Nav, Row, Col } from 'react-bootstrap';
import { useProvider, Toast } from '../context/MenuProvider';
import { useNavigate, useParams, useLocation, Link } from 'react-router-dom';
import AOS from "aos";
import 'aos/dist/aos.css';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import Markdown from '../components/Utils/Markdown';
import dayjs from "dayjs";
import RenderizarItem from '../components/Utils/RenderizarProduto';
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

const ApresentacaoItem = ({ item, carregarTelas }) => {
  const navigate = useNavigate();
  const [expandido, setExpandido] = useState(false);
  const [telas, setTelas] = useState([]);
  const [nextDownUrl, setNextDownUrl] = useState(null);
  const [loadingTelas, setLoadingTelas] = useState(false);
  const [dados, setDados] = useState(item);
  const [loadingMais, setLoadingMais] = useState(false);

  const { crud, hasPerms } = useProvider();
  const { patch, post } = crud || {};

  const toggleSelecionar = async () => {
    navigate(`/painel/slide/${dados?.id}/`);
  };

  const toggleExpand = async () => {
    if (!expandido && telas?.length === 0 && typeof carregarTelas === "function") {
      setLoadingTelas(true);
      const { results, next } = await carregarTelas(dados.id, `/rede/imagens-das-apresentacoes/?apresentacao=${dados.id}&ordering=-ordem`);
      setTelas(results);
      setNextDownUrl(next);
      setLoadingTelas(false);
    }
    setExpandido(!expandido);
  };

  const carregarMais = async () => {
    if (!nextDownUrl || loadingMais) return;
    setLoadingMais(true);
    const { results, next } = await carregarTelas(dados.id, nextDownUrl);
    setTelas((prev) => [...prev, ...results]);
    setNextDownUrl(next);
    setLoadingMais(false);
  };
  
  return (<>
    <RenderizarItem
      col="d-none"
      lm="mb-1"
      //text1={dayjs(dados?.criado_em).format("DD/MM/YYYY dddd")}
      titulo={`${dados?.nome}`}
      text2={(<>
        <Markdown texto={dados?.descricao}></Markdown>
        <Row>
          <Col className="text-muted"><i className="bx bx-time"></i>{dayjs(dados?.criado_em).format("DD/MM/YYYY [às] HH[h]:mm dddd")}</Col>
          {hasPerms(["rede.view_imagemapresentacao"]) && (
            <Col xs="auto">
              <Button variant="outline-secondary" size="sm" className="ms-1" onClick={toggleSelecionar}>
                Abrir
              </Button>
              <Button variant="outline-secondary" size="sm" className="ms-1" onClick={toggleExpand}>
                {expandido ? <i className="bx bx-chevron-up"></i> : <i className="bx bx-chevron-down"></i>}
              </Button>
            </Col>
          )}
          {expandido && (
            <Col xs={12}>
              {loadingTelas && <div className="text-center"><Spinner animation="border" size="sm" /></div>}
              {telas?.map((img) => (
                <div className="mt-1 pt-1 border-top ps-1" style={{ borderLeft: "2px solid lightgray" }}>
                  <Row className="align-items-center">
                    <Col xs="auto">
                      <img 
                        src={img.arquivo} 
                        alt={img.nome} 
                        style={{ height: 60 }} 
                      />
                    </Col>
                    <Col>
                      {img.nome}
                    </Col>
                  </Row>
                </div>
              ))}
              {nextDownUrl && (
                <div className="mt-2 text-center">
                  <Button variant="outline-secondary" size="sm" onClick={carregarMais} disabled={loadingMais}>
                    {loadingMais ? "Carregando..." : "Carregar mais"}
                  </Button>
                </div>
              )}
            </Col>
          )}
        </Row>
      </>)}
    />
  </>);
};

const ListaSlide = () => {
  const [query, setQuery] = useState('');
  const [apresentacoes, setApresentacoes] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);
  const { 
    setLinks, 
    setBtns, 
    crud,
    hasPerms,
  } = useProvider();
  const { get, loading } = crud || {};
  const navigate = useNavigate();

  useEffect(() => {
    buscarApresentacoes(true);
  }, [query]);

  const buscarApresentacoes = async (novaConsulta = false, url = `/rede/apresentacoes/${query?`?search=${query}`:'?ordering=nome,-criado_em'}`) => {
    try {
      const response = await get(url, "apresentacoes");
      if (response && response[0]?.results) {
        setApresentacoes((prev) => novaConsulta ? [...response[0].results] : [...prev, ...response[0].results]);
        setNextUrl(response[0]?.next || null);
      } else {
        setApresentacoes([]);
        setNextUrl(null);
      }
    } catch (err) {
      //alert(JSON.stringify(err))
      console.error("Erro ao buscar apresentações:", err);
    }
  };
  const buscarTelas = async (id, url) => {
    try {
      return (await get(url, "telas"))[0];
    } catch (err) {
      //alert(JSON.stringify(err))
      console.error("Erro ao buscar telas:", err);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
        if (!loading && nextUrl) buscarApresentacoes(false, nextUrl);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading, nextUrl]);


  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out", once: true, mirror: false });
  }, []);
  
  useEffect(() => {
    const canCreate = typeof hasPerms === 'function' && hasPerms(['rede.add_apresentacao']);
    setLinks(canCreate ? [{ name: 'Nova Apresentação', to: '/painel/slide' }] : []);
    setBtns([]);
    return () => { setLinks([]); setBtns([]); };
  }, [setLinks, setBtns, hasPerms]);


  return (
    <div className="list-group">
      {!loading && apresentacoes.length === 0 && (
        <p className="text-center text-muted">Nenhuma apresentação encontrada.</p>
      )}
      {hasPerms(["rede.add_apresentacao"]) && (
        <BotaoFlutuante to="/painel/slide" icon="bi-plus" />
      )}
      <div>
        {apresentacoes.map((c) => (
          <ApresentacaoItem key={c.id} item={c} carregarTelas={buscarTelas}/>
        ))}
      </div>
      {loading && <p className="text-center"><Spinner animation="border" /></p>}
    </div>
  );
};

export default ListaSlide;